import styled from "styled-components";
import device from "src/constants/media";
import { typography, colors } from "src/theme";

export const Wrapper = styled.div`
  flex: 1;
  @media ${device.laptopS} {
    width: 1096px;
    margin: 0 auto;
  }
`;
export const Content = styled.div`
  padding: 24px 24px 80px;
  @media ${device.tablet} {
    padding: 40px 160px 96px 160px;
  }
  @media ${device.laptop} {
    padding: 40px 260px 96px 260px;
  }
`;
export const Title = styled.p`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.greyDark};
  @media ${device.tablet} {
    font-size: 36px;
    line-height: 44px;
  }
`;
export const Text = styled.p`
  margin-top: 40px;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.grey};
  @media ${device.tablet} {
    margin-top: 48px;
  }
`;
export const ButtonContainer = styled.div`
  margin-top: 40px;

  @media (max-width: 768px) {
    button {
      width: 100%;
    }
  }

  @media ${device.tablet} {
    margin-top: 48px;
  }
`;
